
// ROUTES
require('modules/track/routes/track');

// CONTROLLERS
require('modules/track/controllers/track');
require('modules/track/controllers/list');
require('modules/track/controllers/create');
require('modules/track/controllers/edit');

// SERVICES
require('modules/track/services/track');
require('modules/track/services/list');
require('modules/track/services/create');
require('modules/track/services/edit');
require('modules/track/services/delete');


angular.module('unica_track', [

	// ROUTES
	'unica_track.track_routes',

	// CONTROLLERS
	'unica_track.track_controllers',

	// SERVICES
	'unica_track.track_services'

]);


